import React from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import { FaArrowRight } from 'react-icons/fa';
import PageHeader from '../Layout/PageHeader';
import { services } from './Services';

const ServiceDetails = () => {
  const { id } = useParams();
  const service = services.find((item) => item.id === parseInt(id, 10));

  if (!service) {
    return <Navigate to="/services" replace />;
  }

  return (
    <main className="page">
      <div className="page__inner">
        <PageHeader label="Services" title={service.title} description={service.description} />
        <div style={{ textAlign: 'center' }}>
          <Link to={`/contact?service=${encodeURIComponent(service.title)}`} className="button">
            Request a quote <FaArrowRight className="button__icon" />
          </Link>
        </div>
      </div>
    </main>
  );
};

export default ServiceDetails;
